let tokenLoginFailed = false
let tokenLoginInProgress = false

export const isTokenLoginFailed = () => tokenLoginFailed

export const markTokenLoginFailed = () => {
  tokenLoginFailed = true
}

export const clearTokenLoginFailed = () => {
  tokenLoginFailed = false
}

export const tryBeginTokenLogin = () => {
  if (tokenLoginFailed || tokenLoginInProgress) return false
  tokenLoginInProgress = true
  return true
}

export const endTokenLogin = () => {
  tokenLoginInProgress = false
}
